import React from 'react'

export const Arrow = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink">
    <g id="24x24/ArrowLong_Right" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M19.6027304,11 L16.3425076,7.70314549 C15.9541711,7.31044563 15.9577083,6.67729053 16.3504081,6.288954 C16.743108,5.90061747 17.3762631,5.90415464 17.7645996,6.29685451 L22.6606057,11.2478719 C22.7431528,11.321536 22.8123701,11.4082939 22.8663149,11.5034921 C22.9054543,11.571839 22.9358621,11.6438045 22.9575473,11.717772 C23.0507609,12.0306735 22.9956549,12.3892645 22.7405358,12.6698468 C22.73003,12.6814717 22.7192031,12.6929085 22.708055,12.7041457 L17.7645996,17.7031455 C17.3762631,18.0958454 16.743108,18.0993825 16.3504081,17.711046 C15.9577083,17.3227095 15.9541711,16.6895544 16.3425076,16.2968545 L19.6027304,13 L1.99799805,12.9999999 C1.4457133,13 0.997998051,12.5522847 0.997998051,11.9999999 C0.997998051,11.4477153 1.4457133,11 1.99799805,10.9999999 L19.6027304,11 Z"
        id="ArrowPath"
        fill="#172125"></path>
    </g>
  </svg>
)

export const ArrowWhite = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink">
    <g id="24x24/ArrowLong_Right" stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
      <path
        d="M19.6027304,11 L16.3425076,7.70314549 C15.9541711,7.31044563 15.9577083,6.67729053 16.3504081,6.288954 C16.743108,5.90061747 17.3762631,5.90415464 17.7645996,6.29685451 L22.6606057,11.2478719 C22.7431528,11.321536 22.8123701,11.4082939 22.8663149,11.5034921 C22.9054543,11.571839 22.9358621,11.6438045 22.9575473,11.717772 C23.0507609,12.0306735 22.9956549,12.3892645 22.7405358,12.6698468 C22.73003,12.6814717 22.7192031,12.6929085 22.708055,12.7041457 L17.7645996,17.7031455 C17.3762631,18.0958454 16.743108,18.0993825 16.3504081,17.711046 C15.9577083,17.3227095 15.9541711,16.6895544 16.3425076,16.2968545 L19.6027304,13 L1.99799805,12.9999999 C1.4457133,13 0.997998051,12.5522847 0.997998051,11.9999999 C0.997998051,11.4477153 1.4457133,11 1.99799805,10.9999999 L19.6027304,11 Z"
        id="ArrowPath"
        fill="#ffffff"></path>
    </g>
  </svg>
)

export const ArrowRight = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink">
    <g id="Library" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="16x16/ArrowSmall_Right" fill="#172125">
        <path
          d="M10.5237615,3.54623846 C10.7854128,3.80788973 10.7854128,4.23211027 10.5237615,4.49376154 L7.647,7.37 L10.5237615,10.2462385 C10.7854128,10.5078897 10.7854128,10.9321103 10.5237615,11.1937615 C10.2621103,11.4554128 9.83788973,11.4554128 9.57623846,11.1937615 L6.22623846,7.84376154 C5.96458718,7.58211027 5.96458718,7.15788973 6.22623846,6.89623846 L9.57623846,3.54623846 C9.83788973,3.28458718 10.2621103,3.28458718 10.5237615,3.54623846 Z"
          id="icon"
          transform="translate(8.375000, 7.370000) scale(-1, 1) translate(-8.375000, -7.370000) "></path>
      </g>
    </g>
  </svg>
)

export const HomeIcon = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink">
    <defs>
      <path
        d="M6.7,14.7398325 C6.7,15.1096725 6.39984,15.4098325 6.03,15.4098325 L2.34299,15.4098325 C1.41772,15.4098325 0.67,14.6607725 0.67,13.7328225 L0.67,8.0378225 C0.67,7.2874225 1.09947,6.3601425 1.67165,5.8737225 L7.60584,0.8292925 C7.85642,0.6169025 8.22358,0.6169025 8.47416,0.8292925 L14.40835,5.8737225 C14.98187,6.3608125 15.41,7.2867525 15.41,8.0378225 L15.41,13.7328225 C15.41,14.6614425 14.66094,15.4098325 13.73433,15.4098325 L10.05,15.4098325 C9.68016,15.4098325 9.38,15.1096725 9.38,14.7398325 L9.38,10.7198325 L6.7,10.7198325 L6.7,14.7398325 Z M13.73433,14.0698325 C13.92126,14.0698325 14.07,13.9210925 14.07,13.7328225 L14.07,8.0378225 C14.07,7.6800425 13.81473,7.1272925 13.5407,6.8948025 L8.04,2.2188725 L2.5393,6.8948025 C2.26661,7.1266225 2.01,7.6807125 2.01,8.0378225 L2.01,13.7328225 C2.01,13.9210925 2.15807,14.0698325 2.34299,14.0698325 L5.36,14.0698325 L5.36,10.0498325 C5.36,9.6799925 5.66016,9.3798325 6.03,9.3798325 L10.05,9.3798325 C10.41984,9.3798325 10.72,9.6799925 10.72,10.0498325 L10.72,14.0698325 L13.73433,14.0698325 Z"
        id="path-1"></path>
    </defs>
    <g id="Library" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="16x16/Home">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1"></use>
        </mask>
        <use id="icon" fill="#172125" xlinkHref="#path-1"></use>
      </g>
    </g>
  </svg>
)

export const LinkedInIcon = () => (
  <svg viewBox="6 7 19 19" xmlns="https://www.w3.org/2000/svg" fill="#172125" fillRule="evenodd">
    <path d="M11.791 13.85v9.954H8.477v-9.955h3.314zm.211-3.074A1.59 1.59 0 0 1 11.495 12c-.345.328-.799.492-1.361.492h-.02c-.55 0-.991-.164-1.326-.492a1.646 1.646 0 0 1-.502-1.225c0-.496.172-.906.517-1.23.345-.326.795-.488 1.351-.488.556 0 1.001.162 1.336.487.335.325.506.735.512 1.23zm4.922 4.488c.128-.201.258-.378.392-.53.14-.161.33-.336.567-.523a2.61 2.61 0 0 1 .874-.437 3.982 3.982 0 0 1 1.15-.156c1.145 0 2.066.38 2.763 1.14.696.76 1.044 1.874 1.044 3.34v5.706H20.41V18.48c0-.703-.136-1.254-.407-1.652-.271-.399-.695-.598-1.27-.598-.423 0-.776.115-1.06.346a2.136 2.136 0 0 0-.638.86c-.074.2-.11.471-.11.813v5.555h-3.306c.014-2.672.02-4.839.02-6.5 0-1.66-.003-2.651-.01-2.973l-.01-.482h3.305v1.415z"></path>
  </svg>
)

export const TwitterIcon = () => (
  <svg viewBox="6 7 19 19" xmlns="https://www.w3.org/2000/svg" fill="#172125" fillRule="evenodd">
    <path d="M23.915 11.67a6.798 6.798 0 0 1-1.627 1.677 9.217 9.217 0 0 1-.372 3.028 9.42 9.42 0 0 1-1.16 2.497 9.812 9.812 0 0 1-1.853 2.114c-.717.613-1.58 1.102-2.592 1.467a9.484 9.484 0 0 1-3.244.547 9.01 9.01 0 0 1-4.982-1.456c.234.026.495.04.783.04 1.507 0 2.85-.462 4.028-1.386a3.163 3.163 0 0 1-1.888-.648 3.173 3.173 0 0 1-1.145-1.602c.22.033.425.05.612.05.288 0 .573-.037.854-.11a3.192 3.192 0 0 1-1.863-1.12 3.135 3.135 0 0 1-.738-2.065v-.04c.455.254.944.392 1.466.412A3.24 3.24 0 0 1 9.14 13.92a3.161 3.161 0 0 1-.392-1.547c0-.59.147-1.135.442-1.638a9.197 9.197 0 0 0 2.958 2.396 9.04 9.04 0 0 0 3.731 1 3.604 3.604 0 0 1-.08-.744c0-.897.317-1.662.95-2.295a3.127 3.127 0 0 1 2.295-.95c.937 0 1.727.342 2.37 1.025a6.362 6.362 0 0 0 2.06-.783 3.15 3.15 0 0 1-1.427 1.788 6.464 6.464 0 0 0 1.868-.502z" />
  </svg>
)

export const EnlargeableImage = () => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      className="search-icon"
      clipRule="evenodd"
      d="m10.7414 10.464 3.8023 3.8022c.262.2613.262.6861 0 .9474-.2613.262-.6861.262-.9474 0l-3.80224-3.8022c-1.0318.8254-2.34031 1.3185-3.76406 1.3185-3.33057 0-6.03-2.6994-6.03-6.02998 0-3.33057 2.69943-6.029998 6.03-6.029998s6.03 2.699428 6.03 6.029998c0 1.42375-.4931 2.73226-1.3186 3.76408zm-5.3814-4.43408v-1.675c0-.36984.30016-.67.67-.67s.67.30016.67.67v1.675h1.675c.36984 0 .67.30016.67.67s-.30016.67-.67.67h-1.675v1.675c0 .36984-.30016.67-.67.67s-.67-.30016-.67-.67v-1.675h-1.675c-.36984 0-.67-.30016-.67-.67s.30016-.67.67-.67zm.67 5.35998c2.59022 0 4.69-2.09976 4.69-4.68998s-2.09978-4.69-4.69-4.69-4.69 2.09978-4.69 4.69 2.09978 4.68998 4.69 4.68998z"
      fillRule="evenodd"
    />
  </svg>
)

export const MediaTextMaskNone = () => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      className="search-icon"
      clipRule="evenodd"
      d="m10.7414 10.464 3.8023 3.8022c.262.2613.262.6861 0 .9474-.2613.262-.6861.262-.9474 0l-3.80224-3.8022c-1.0318.8254-2.34031 1.3185-3.76406 1.3185-3.33057 0-6.03-2.6994-6.03-6.02998 0-3.33057 2.69943-6.029998 6.03-6.029998s6.03 2.699428 6.03 6.029998c0 1.42375-.4931 2.73226-1.3186 3.76408zm-5.3814-4.43408v-1.675c0-.36984.30016-.67.67-.67s.67.30016.67.67v1.675h1.675c.36984 0 .67.30016.67.67s-.30016.67-.67.67h-1.675v1.675c0 .36984-.30016.67-.67.67s-.67-.30016-.67-.67v-1.675h-1.675c-.36984 0-.67-.30016-.67-.67s.30016-.67.67-.67zm.67 5.35998c2.59022 0 4.69-2.09976 4.69-4.68998s-2.09978-4.69-4.69-4.69-4.69 2.09978-4.69 4.69 2.09978 4.68998 4.69 4.68998z"
      fillRule="evenodd"
    />
  </svg>
)

export const QuoteImage = () => (
  <svg
    width="320px"
    height="240px"
    viewBox="0 0 320 240"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className="Quote__Bg-Image">
    <g id="modules" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Quote__Bg-Image-Inner" transform="translate(-1240.000000, 0.000000)" fill="#111212">
        <path
          d="M1560,240 L1437.2093,240 C1424.84721,204.444267 1418.60465,167.703893 1418.60465,129.230769 C1418.60465,91.8516622 1429.68519,60.7408622 1452.09302,36.9230769 C1474.00802,12.1480267 1506.62538,-1.75442651e-13 1548.83721,0 L1548.83721,59.0769231 C1517.23789,57.7777778 1501.00724,77.3331378 1500.46512,118.153846 L1500.46512,129.230769 L1560,129.230769 L1560,240 Z M1381.39535,240 L1258.60465,240 C1246.24256,204.444267 1240,167.703893 1240,129.230769 C1240,91.8516622 1251.08054,60.7408622 1273.48837,36.9230769 C1295.40337,12.1480267 1328.02073,-1.75442651e-13 1370.23256,0 L1370.23256,59.0769231 C1338.63324,57.7777778 1322.40259,77.3331378 1321.86047,118.153846 L1321.86047,129.230769 L1381.39535,129.230769 L1381.39535,240 Z"
          id="quotes"></path>
      </g>
    </g>
  </svg>
)

export const SubscribeModalClose = ({ handleClose }: any) => (
  <svg
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="SubscribeModal__Close-Icon"
    data-cy="SubscribeModal__Close-Icon"
    onClick={handleClose}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.293.293a1 1 0 1 1 1.414 1.414L10.414 9l7.293 7.293a1 1 0 0 1-1.414 1.414L9 10.414l-7.293 7.293a1 1 0 0 1-1.414-1.414L7.586 9 .293 1.707A1 1 0 0 1 1.707.293L9 7.586 16.293.293Z"
      fill="#fff"
    />
  </svg>
)

export const BlogTwitter = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.05353 2L9.54748 13.5827L1 23H2.92385L10.4073 14.7548L16.4535 23H23L14.028 10.7659L21.984 2H20.0601L13.1685 9.59341L7.6 2H1.05353ZM3.88263 3.44511H6.89005L20.1705 21.5549H17.1631L3.88263 3.44511Z"
      fill="#73858C"
    />
  </svg>
)

export const BlogLinkedIn = () => (
  <svg xmlns="https://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M10.558,18.024H6.519c.017-3.356.025-5.954.025-7.943s0-3.234-.013-3.634l-.013-.589h4.039V7.585a5.3,5.3,0,0,1,.479-.649,5.226,5.226,0,0,1,.694-.638A3.2,3.2,0,0,1,12.8,5.764a4.883,4.883,0,0,1,1.4-.19,4.381,4.381,0,0,1,3.377,1.393,5.871,5.871,0,0,1,1.276,4.082v6.972H14.818V11.516a3.569,3.569,0,0,0-.5-2.02,1.752,1.752,0,0,0-1.552-.73,2,2,0,0,0-1.3.423,2.631,2.631,0,0,0-.779,1.049,2.985,2.985,0,0,0-.135.995v6.79Zm-6.273,0H.233V5.856H4.285V18.022ZM2.259,4.2H2.235A2.228,2.228,0,0,1,.614,3.6,2.021,2.021,0,0,1,0,2.1,1.984,1.984,0,0,1,.633.6,2.319,2.319,0,0,1,2.283,0,2.253,2.253,0,0,1,3.916.6a2.055,2.055,0,0,1,.626,1.5,1.951,1.951,0,0,1-.62,1.5A2.324,2.324,0,0,1,2.259,4.2Z"
      transform="translate(2.571 2.96)"></path>
  </svg>
)

export const BlogFacebook = () => (
  <svg xmlns="https://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M10.607.147V3.388H8.68a1.8,1.8,0,0,0-1.424.442,2.034,2.034,0,0,0-.368,1.326v2.32h3.6l-.479,3.634H6.887v9.318H3.131V11.11H0V7.477H3.131V4.8A4.749,4.749,0,0,1,4.407,1.258,4.634,4.634,0,0,1,7.808,0,20.309,20.309,0,0,1,10.607.147Z"
      transform="translate(6.881 1.143)"></path>
  </svg>
)

export const DownCarat = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="BlogNavDropdown__Arrow">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.86006 11.0601C7.7654 10.9662 7.71216 10.8384 7.71216 10.7051C7.71216 10.5717 7.7654 10.4439 7.86006 10.3501L8.06006 10.1501C8.15413 10.0524 8.28447 9.99809 8.42006 10.0001H15.5801C15.7156 9.99809 15.846 10.0524 15.9401 10.1501L16.1401 10.3501C16.2347 10.4439 16.288 10.5717 16.288 10.7051C16.288 10.8384 16.2347 10.9662 16.1401 11.0601L12.3501 14.8501C12.2593 14.9467 12.1326 15.0016 12.0001 15.0016C11.8675 15.0016 11.7408 14.9467 11.6501 14.8501L7.86006 11.0601Z"
      fill="white"
    />
  </svg>
)

export const DownArrow = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="BlogNav__Mobile-Menu-Arrow">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.81378 4.2165L8.04009 10.4428L14.2664 4.2165C14.5277 3.95453 14.9525 3.95453 15.2138 4.2165C15.4757 4.4778 15.4757 4.90258 15.2138 5.16388L8.51378 11.8639C8.25248 12.1258 7.8277 12.1258 7.5664 11.8639L0.866399 5.16388C0.604429 4.90258 0.604429 4.4778 0.866399 4.2165C1.1277 3.95453 1.55248 3.95453 1.81378 4.2165Z"
      fill="white"
    />

    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="4" width="16" height="9">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.81378 4.2165L8.04009 10.4428L14.2664 4.2165C14.5277 3.95453 14.9525 3.95453 15.2138 4.2165C15.4757 4.4778 15.4757 4.90258 15.2138 5.16388L8.51378 11.8639C8.25248 12.1258 7.8277 12.1258 7.5664 11.8639L0.866399 5.16388C0.604429 4.90258 0.604429 4.4778 0.866399 4.2165C1.1277 3.95453 1.55248 3.95453 1.81378 4.2165Z"
        fill="white"
      />
    </mask>

    <g mask="url(#mask0)"></g>
  </svg>
)

export const XIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L13.4142 12L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L12 13.4142L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071C2.90237 20.3166 2.90237 19.6834 3.29289 19.2929L10.5858 12L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L12 10.5858L19.2929 3.29289Z"
      fill="white"
      fillOpacity="0.301961"
    />
  </svg>
)

export const TwitterNewsroom = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.05353 2L9.54748 13.5827L1 23H2.92385L10.4073 14.7548L16.4535 23H23L14.028 10.7659L21.984 2H20.0601L13.1685 9.59341L7.6 2H1.05353ZM3.88263 3.44511H6.89005L20.1705 21.5549H17.1631L3.88263 3.44511Z"
      fill="#73858C"
    />
  </svg>
)

export const LinkedinNewsroom = () => (
  <svg xmlns="https://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M10.558,18.024H6.519c.017-3.356.025-5.954.025-7.943s0-3.234-.013-3.634l-.013-.589h4.039V7.585a5.3,5.3,0,0,1,.479-.649,5.226,5.226,0,0,1,.694-.638A3.2,3.2,0,0,1,12.8,5.764a4.883,4.883,0,0,1,1.4-.19,4.381,4.381,0,0,1,3.377,1.393,5.871,5.871,0,0,1,1.276,4.082v6.972H14.818V11.516a3.569,3.569,0,0,0-.5-2.02,1.752,1.752,0,0,0-1.552-.73,2,2,0,0,0-1.3.423,2.631,2.631,0,0,0-.779,1.049,2.985,2.985,0,0,0-.135.995v6.79Zm-6.273,0H.233V5.856H4.285V18.022ZM2.259,4.2H2.235A2.228,2.228,0,0,1,.614,3.6,2.021,2.021,0,0,1,0,2.1,1.984,1.984,0,0,1,.633.6,2.319,2.319,0,0,1,2.283,0,2.253,2.253,0,0,1,3.916.6a2.055,2.055,0,0,1,.626,1.5,1.951,1.951,0,0,1-.62,1.5A2.324,2.324,0,0,1,2.259,4.2Z"
      transform="translate(2.571 2.96)"></path>
  </svg>
)

export const FacebookNewsroom = () => (
  <svg xmlns="https://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M10.607.147V3.388H8.68a1.8,1.8,0,0,0-1.424.442,2.034,2.034,0,0,0-.368,1.326v2.32h3.6l-.479,3.634H6.887v9.318H3.131V11.11H0V7.477H3.131V4.8A4.749,4.749,0,0,1,4.407,1.258,4.634,4.634,0,0,1,7.808,0,20.309,20.309,0,0,1,10.607.147Z"
      transform="translate(6.881 1.143)"></path>
  </svg>
)

export const BlueArrowDown = ({ isEvents }: any) => (
  <svg
    width="9"
    height="5"
    viewBox="0 0 9 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="Filter-Group__Arrow">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.213619 0.229708C-0.0465667 0.492817 -0.0441968 0.917031 0.218912 1.17722L3.56824 4.48933C3.62343 4.54408 3.6858 4.58727 3.75233 4.61889C3.93396 4.70522 4.14627 4.7051 4.3277 4.61889C4.39424 4.58727 4.45661 4.54408 4.5118 4.48933L7.86113 1.17722C8.12424 0.917031 8.12661 0.492817 7.86642 0.229708C7.60623 -0.0334005 7.18202 -0.0357699 6.91891 0.224415L4.04002 3.07132L1.16113 0.224415C0.898018 -0.0357699 0.473804 -0.0334005 0.213619 0.229708Z"
      fill={isEvents ? '#38c6f4' : '#0079BF'}
    />
  </svg>
)

export const RedX = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99 5.99999L11.495 1.49496C11.7684 1.2216 11.7684 0.77838 11.495 0.505013C11.2217 0.231646 10.7784 0.231646 10.5051 0.505013L6.00005 5.01004L1.49502 0.505013C1.22166 0.231646 0.778442 0.231646 0.505075 0.505013C0.231708 0.77838 0.231708 1.2216 0.505075 1.49496L5.0101 5.99999L0.505074 10.505C0.231707 10.7784 0.231707 11.2216 0.505074 11.495C0.778441 11.7683 1.22166 11.7683 1.49502 11.495L6.00005 6.98994L10.5051 11.495C10.7784 11.7683 11.2217 11.7683 11.495 11.495C11.7684 11.2216 11.7684 10.7784 11.495 10.505L6.99 5.99999Z"
      fill="#FA4616"
    />
  </svg>
)

export const ResourceSearchIcon = () => (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="search-icon">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.741 10.464 3.803 3.802a.67.67 0 1 1-.948.948L9.794 11.41A6.03 6.03 0 1 1 6.03.67a6.03 6.03 0 0 1 4.711 9.794Zm-4.711.926a4.69 4.69 0 1 0 0-9.38 4.69 4.69 0 0 0 0 9.38Z"
      fill="#fff"
    />
    <mask id="a" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m10.741 10.464 3.803 3.802a.67.67 0 1 1-.948.948L9.794 11.41A6.03 6.03 0 1 1 6.03.67a6.03 6.03 0 0 1 4.711 9.794Zm-4.711.926a4.69 4.69 0 1 0 0-9.38 4.69 4.69 0 0 0 0 9.38Z"
        fill="#fff"
      />
    </mask>
  </svg>
)

export const ResourceClearSearch = ({ clearSearch, searchText }: any) => (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={clearSearch}
    className={`close-icon ${searchText.length ? 'active' : ''}`}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.99 8 4.505-4.505a.7.7 0 0 0-.99-.99L8 7.01 3.495 2.505a.7.7 0 0 0-.99.99L7.01 8l-4.505 4.505a.7.7 0 1 0 .99.99L8 8.99l4.505 4.505a.7.7 0 0 0 .99-.99L8.99 8Z"
      fill="#172125"
    />
  </svg>
)

export const VideoPlayIcon = (props: { className: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      className={props.className}>
      <circle
        className="VideoPlayIcon__Circle"
        cx="28"
        cy="28"
        r="28"
        fill="white"
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38 27.8134V28.1867C37.9989 28.5421 37.8117 28.871 37.5066 29.0534L25.5733 36.0001C24.8533 36.4267 24.48 36.4267 24.16 36.2401L23.8266 36.0534C23.5296 35.876 23.3436 35.5593 23.3333 35.2134V20.7867C23.3344 20.4313 23.5216 20.1024 23.8266 19.9201L24.16 19.7334C24.48 19.5467 24.8533 19.5467 25.7866 20.0934L37.5066 26.9467C37.8117 27.1291 37.9989 27.458 38 27.8134Z"
        fill="#FA4616"
      />
    </svg>
  )
}

export const ListBulletIcon = () => {
  return (
    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.625 4.11159C2.28125 4.11159 1.96733 4.02779 1.68324 3.86017C1.39915 3.68972 1.17188 3.46245 1.00142 3.17836C0.833807 2.89426 0.75 2.58034 0.75 2.23659C0.75 1.89 0.833807 1.57608 1.00142 1.29483C1.17188 1.01074 1.39915 0.78489 1.68324 0.617276C1.96733 0.446821 2.28125 0.361594 2.625 0.361594C2.97159 0.361594 3.28551 0.446821 3.56676 0.617276C3.85085 0.78489 4.0767 1.01074 4.24432 1.29483C4.41477 1.57608 4.5 1.89 4.5 2.23659C4.5 2.58034 4.41477 2.89426 4.24432 3.17836C4.0767 3.46245 3.85085 3.68972 3.56676 3.86017C3.28551 4.02779 2.97159 4.11159 2.625 4.11159Z"
        fill="black"
        id="icon"
      />
    </svg>
  )
}

export const BioLinkedIn = () => (
  <svg viewBox="6 7 19 19" xmlns="https://www.w3.org/2000/svg" fill="#172125" fillRule="evenodd">
    <path d="M11.791 13.85v9.954H8.477v-9.955h3.314zm.211-3.074A1.59 1.59 0 0 1 11.495 12c-.345.328-.799.492-1.361.492h-.02c-.55 0-.991-.164-1.326-.492a1.646 1.646 0 0 1-.502-1.225c0-.496.172-.906.517-1.23.345-.326.795-.488 1.351-.488.556 0 1.001.162 1.336.487.335.325.506.735.512 1.23zm4.922 4.488c.128-.201.258-.378.392-.53.14-.161.33-.336.567-.523a2.61 2.61 0 0 1 .874-.437 3.982 3.982 0 0 1 1.15-.156c1.145 0 2.066.38 2.763 1.14.696.76 1.044 1.874 1.044 3.34v5.706H20.41V18.48c0-.703-.136-1.254-.407-1.652-.271-.399-.695-.598-1.27-.598-.423 0-.776.115-1.06.346a2.136 2.136 0 0 0-.638.86c-.074.2-.11.471-.11.813v5.555h-3.306c.014-2.672.02-4.839.02-6.5 0-1.66-.003-2.651-.01-2.973l-.01-.482h3.305v1.415z"></path>
  </svg>
)

export const BioTwitter = () => (
  <svg viewBox="6 7 19 19" xmlns="https://www.w3.org/2000/svg" fill="#172125" fillRule="evenodd">
    <path d="M23.915 11.67a6.798 6.798 0 0 1-1.627 1.677 9.217 9.217 0 0 1-.372 3.028 9.42 9.42 0 0 1-1.16 2.497 9.812 9.812 0 0 1-1.853 2.114c-.717.613-1.58 1.102-2.592 1.467a9.484 9.484 0 0 1-3.244.547 9.01 9.01 0 0 1-4.982-1.456c.234.026.495.04.783.04 1.507 0 2.85-.462 4.028-1.386a3.163 3.163 0 0 1-1.888-.648 3.173 3.173 0 0 1-1.145-1.602c.22.033.425.05.612.05.288 0 .573-.037.854-.11a3.192 3.192 0 0 1-1.863-1.12 3.135 3.135 0 0 1-.738-2.065v-.04c.455.254.944.392 1.466.412A3.24 3.24 0 0 1 9.14 13.92a3.161 3.161 0 0 1-.392-1.547c0-.59.147-1.135.442-1.638a9.197 9.197 0 0 0 2.958 2.396 9.04 9.04 0 0 0 3.731 1 3.604 3.604 0 0 1-.08-.744c0-.897.317-1.662.95-2.295a3.127 3.127 0 0 1 2.295-.95c.937 0 1.727.342 2.37 1.025a6.362 6.362 0 0 0 2.06-.783 3.15 3.15 0 0 1-1.427 1.788 6.464 6.464 0 0 0 1.868-.502z" />
  </svg>
)

export const ArrowLink = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.86135 12.1952L8.80407 13.1379L13.9416 8.00035L8.80407 2.86279L7.86135 3.80551L11.3896 7.3338H2V8.667H11.3895L7.86135 12.1952Z"
      fill="white"
    />
  </svg>
)

export const NavSearch = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.032 15.618L21.707 21.293C22.098 21.683 22.098 22.317 21.707 22.707C21.317 23.098 20.683 23.098 20.293 22.707L14.618 17.032C13.078 18.264 11.125 19 9 19C4.029 19 0 14.971 0 10C0 5.029 4.029 1 9 1C13.971 1 18 5.029 18 10C18 12.125 17.264 14.078 16.032 15.618ZM9 17C12.866 17 16 13.866 16 10C16 6.134 12.866 3 9 3C5.134 3 2 6.134 2 10C2 13.866 5.134 17 9 17Z"
      fill="#172125"
    />
    <mask id="mask0_6480_4180" maskUnits="userSpaceOnUse" x="0" y="1" width="22" height="22">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.032 15.618L21.707 21.293C22.098 21.683 22.098 22.317 21.707 22.707C21.317 23.098 20.683 23.098 20.293 22.707L14.618 17.032C13.078 18.264 11.125 19 9 19C4.029 19 0 14.971 0 10C0 5.029 4.029 1 9 1C13.971 1 18 5.029 18 10C18 12.125 17.264 14.078 16.032 15.618ZM9 17C12.866 17 16 13.866 16 10C16 6.134 12.866 3 9 3C5.134 3 2 6.134 2 10C2 13.866 5.134 17 9 17Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_6480_4180)"></g>
  </svg>
)

export const CardSliderArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4711 25.8047L11.5283 24.8619L20.3902 16L11.5283 7.13804L12.4711 6.19523L22.2759 16L12.4711 25.8047Z"
      fill="black"
    />
  </svg>
)

export const SelectDropArrow = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.29297 9.20718L5.70718 7.79297L12.0001 14.0859L18.293 7.79297L19.7072 9.20718L12.0001 16.9143L4.29297 9.20718Z"
      fill="black"
    />
  </svg>
)

export const ShareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6C13 6.33707 13.0417 6.6644 13.1202 6.97712L8.9212 9.26748C8.19127 8.48747 7.15256 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16C7.15259 16 8.19131 15.5125 8.92125 14.7325L13.1202 17.0228C13.0417 17.3356 13 17.6629 13 18C13 20.2091 14.7909 22 17 22C19.2091 22 21 20.2091 21 18C21 15.7909 19.2091 14 17 14C15.8474 14 14.8087 14.4875 14.0788 15.2675L9.87979 12.9771C9.95831 12.6644 10 12.3371 10 12C10 11.6629 9.9583 11.3355 9.87978 11.0228L14.0787 8.73246C14.8087 9.51251 15.8474 10 17 10C19.2091 10 21 8.20914 21 6C21 3.79086 19.2091 2 17 2C14.7909 2 13 3.79086 13 6ZM17 8C18.1046 8 19 7.10457 19 6C19 4.89543 18.1046 4 17 4C15.9117 4 15.0264 4.86931 15.0006 5.95146C15.0002 5.96759 15 5.98377 15 6C15 6.72279 15.3834 7.35603 15.958 7.70742C16.2614 7.89303 16.6182 8 17 8ZM6 10C6.38174 10 6.7385 10.1069 7.04195 10.2925C7.61654 10.6439 8 11.2772 8 12C8 12.7228 7.61657 13.3561 7.04201 13.7074C6.73855 13.893 6.38177 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10ZM15.958 16.2925C15.3834 16.6439 15 17.2772 15 18C15 18.0162 15.0002 18.0324 15.0006 18.0485C15.0263 19.1306 15.9116 20 17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C16.6182 16 16.2615 16.107 15.958 16.2925Z"
      fill="#0079BF"></path>
  </svg>
)

export const CheckMark = () => (
  <svg width="1em" height="1em" viewBox="0 0 12 9" fill="#EEE">
    <path d="M3.713 7.227L.955 4.509l-.741.729 3.604 3.551L11.786.94l-.741-.73-7.122 7.017z"></path>
  </svg>
)

export const SearchCloseIcon = ({ clearSearch }: any) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="ClearSearch"
    onClick={clearSearch}>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    <path d="M0 0h24v24H0z" fill="none"></path>
  </svg>
)

export const HandleSearchIcon = ({ handleSearch }: any) => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    xlinkHref="https://www.w3.org/1999/xlink"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    id="searchRecordIcon"
    onClick={handleSearch}>
    <defs>
      <path
        id="search2-a"
        d="M10.741 10.464l3.803 3.802a.67.67 0 11-.948.948L9.794 11.41A6.03 6.03 0 116.03.67a6.03 6.03 0 014.711 9.794zm-4.711.926a4.69 4.69 0 100-9.38 4.69 4.69 0 000 9.38z"></path>
    </defs>
    <use fillRule="evenodd" xlinkHref="#search2-a"></use>
  </svg>
)

export const ArrowNewCTA = () => (
  <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9584 19.2732L13.3724 20.6873L23.4119 10.6478L13.3724 0.608398L11.9584 2.02247L19.5838 9.64793H0V11.6477H19.5838L11.9584 19.2732Z"></path>
  </svg>
)
